//import logo from './logo.svg';
import './App.css';
import { useState, useEffect } from 'react';
import { initialUser, initialProfiles, initialIncome, initialExpense, initialDebt } from './constants/initialState';
import GoogleAuth from './components/google-auth/GoogleAuth';
import SettingsPane from './components/settings-pane/SettingsPane';
import PageTabs from './components/page-tabs/PageTabs';
import BudgetForm from './components/budget-form/BudgetForm';
import DebtForm from './components/debt-form/DebtForm';
import TotalBlock from './components/total-block/TotalBlock';
import LoginModal from './components/modals/login-modal/LoginModal';
import SaveBlock from "./components/save-block/SaveBlock";
import UserGuide from './components/user-guide/UserGuide';
import Blog from './components/blog/Blog';
import Footer from './components/footer/Footer';
import ErrorModal from './components/modals/error-modal/ErrorModal';
import ActivationModal from './components/modals/activation-modal/ActivationModal';
import MfaModal from './components/modals/mfa-modal/MfaModal';
import MfaVerificationModal from './components/modals/mfa-modal/MfaVerificationModal';
import profileReducer from './hooks/useProfileReducer';
import userReducer from './hooks/useUserReducer';
import incomeDataReducer from './hooks/useIncomeDataReducer';
import debtDataReducer from './hooks/useDebtDataReducer';
import usePersistReducer from './hooks/usePersistReducer';
import useAppHandlers from './hooks/useAppHandlers';
import { Container, Row, Form, Button, Col } from 'react-bootstrap';
import Spinner from 'react-bootstrap/Spinner';
import { Tooltip } from 'react-tooltip'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-tooltip/dist/react-tooltip.css'
import ConfirmationModal from './components/modals/confirm-modal/ConfirmationModal';


function App() {
  const [loginShow, setLoginShow] = useState(false);
  const [errorShow, setErrorShow] = useState(false);
  const [errorTitle, setErrorTitle] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [confirmShow, setConfirmShow] = useState(false);
  const [confirmTitle, setConfirmTitle] = useState('');
  const [confirmMessage, setConfirmMessage] = useState('');
  const [confirmButtonType, setConfirmButtonType] = useState('danger');
  const [confirmButtonText, setConfirmButtonText] = useState('Delete');
  const [onConfirm, setOnConfirm] = useState(null);
  const [confirmArgs, setConfirmArgs] = useState([]);
  const [activateShow, setActivateShow] = useState(false);
  const [activateTitle, setActivateTitle] = useState('');
  const [activateMessage, setActivateMessage] = useState('');
  const [activateSuccess, setActivateSuccess] = useState(false);
  const [mfaShow, setMfaShow] = useState(false);
  const [mfaVerificationShow, setMfaVerificationShow] = useState(false);
  const [mfaDetails, setMfaDetails] = useState({mfaRequired: false, mfaToken: '', mfaType: ''});
  const [loading, setLoading] = useState(false);
  const [newProfileName, setNewProfileName] = useState('');

  const [sortOptions] = useState([
    {value:"amount", option:"Amount (lowest first)"},
    {value:"amount 2", option:"Amount (highest first)"},
    {value:"current", option:"Current balance (lowest first)"},
    {value:"current 2", option:"Current balance (highest first)"},
    {value:"status", option:"Status (lowest first)"},
    {value:"status 2", option:"Status (highest first)"},
    {value:"apr", option:"APR (lowest first)"},
    {value:"apr 2", option:"APR (highest first)"},
    {value:"minimumPayment", option:"Minimum payment (lowest first)"},
    {value:"minimumPayment 2", option:"Minimum payment (highest first)"}
  ]);
  const [selectedSort, setSelectedSort] = useState('status');
  const [editingProfile, setEditingProfile] = useState(false);  
  
  const [profiles, profileDispatch] = usePersistReducer("profiles", initialProfiles, profileReducer);
  const [userData, userDispatch] = usePersistReducer("userData", initialUser, userReducer);
  const [incomeData, incomeDispatch] = usePersistReducer("incomeData", initialIncome, incomeDataReducer);
  const [expenseData, expenseDispatch] = usePersistReducer("expenseData", initialExpense, incomeDataReducer);
  const [debtData, debtDispatch] = usePersistReducer("debtData", initialDebt, debtDataReducer);
  
  const {
    sendDeleteUser,
    handleCreateProfile,
    handleDeleteProfile,
    handleSave,
    handleReloadSaved,
    handleYearCalcSwitch,
    handleLoggedIn,
    handleEmailUpdate,
    handleNameUpdate,
    handleSurnameUpdate,
    handleMfaEnabled,
    handleMfaType,
    handleDisableMfa,
    handleAddIncome,
    handleChangeIncome,
    handleUpdateIncome,
    handleRemoveIncome,
    handleCreateIncomeDescription,
    handleAddExpense,
    handleChangeExpense,
    handleUpdateExpense,
    handleRemoveExpense,
    handleCreateExpenseDescription,
    handleAutoWeekly,
    handleManualSwitch,
    handleRepaymentType,
    handleAddAutoPayment,
    handleAddDebt,
    handleChangeDebt,
    handleChangeDebtPeriod,
    handleUpdateDebt,
    handleBlurUpdateDebt,
    handleRemoveDebt,
    handleCreateDebtDescription,
    handleChangeWeekly,
    handleAddTransaction,
    handleChangeTransaction,
    handleRemoveTransaction,
    handleDebtSort,
    handleDebtRefresh,
    handleLogOut,
    getProfile,
  } = useAppHandlers({
    profileDispatch,
    incomeDispatch,
    expenseDispatch,
    debtDispatch,
    userDispatch,
    profiles,
    userData,
    selectedSort,
    setSelectedSort,
    initialIncome,
    initialExpense,
    initialDebt,
    setNewProfileName,
    setEditingProfile,
    setErrorShow,
    setErrorTitle,
    setErrorMessage,
    setLoading,
  });

  const getQueryParam = (query) => {
    const { search } = window.location;
    const searchParameters = new URLSearchParams(search);
    if (searchParameters.size === 0 || !searchParameters.has(query)) {
      window.history.replaceState(null, "", "/");
      return;
    }
    const value = searchParameters.get(query)==="true";
    window.history.replaceState(null, "", "/");
    setActivateShow(true);
    setActivateTitle(value ? "Account Activated" : "Activation Failed");
    setActivateMessage(value ? "Your account has been successfully activated. You can now log in and start using the app!" : 
    "There was an issue activating your account. Please try again or contact support if the issue persists.");
    setActivateSuccess(value);
  };

  useEffect(() => {
    getQueryParam("activated");
  }, []);

  const tabs = [
    {key: 'income', title: 'Income/Expenses', shortTitle: 'In/Out',
      content: <Row>
          <BudgetForm
            title='Income'
            handleAdd={handleAddIncome}
            handleChange={handleChangeIncome}
            handleRemove={handleRemoveIncome}
            handleCreateDescription={handleCreateIncomeDescription}
            handleUpdate={handleUpdateIncome}
            yearCalc={userData.selectedProfile.yearCalc}
            data={incomeData}
            category="INCOME"
          />
          <BudgetForm
            title="Expenses"
            handleAdd={handleAddExpense}
            handleChange={handleChangeExpense}
            handleRemove={handleRemoveExpense}
            handleCreateDescription={handleCreateExpenseDescription}
            handleUpdate={handleUpdateExpense}
            yearCalc={userData.selectedProfile.yearCalc}
            data={expenseData}
            category="EXPENSE"
            debtData={debtData}
          />
          <TotalBlock
            incomeData={incomeData}
            expenseData={expenseData}
            debtData={debtData}
            yearCalc={userData.selectedProfile.yearCalc}
          />
        </Row>
    },
    {key: 'debt', title:'Debt', shortTitle: 'Debt', content: <Row>
        <DebtForm
          title='Debt'
          handleManualSwitch={handleManualSwitch}
          handleChangeDebtPeriod={handleChangeDebtPeriod}
          handleAutoWeekly={handleAutoWeekly}
          handleAddAutoPayment={handleAddAutoPayment}
          handleRepaymentType={handleRepaymentType}
          handleAdd={handleAddDebt}
          handleChange={handleChangeDebt}
          handleRemove={handleRemoveDebt}
          handleCreateDescription={handleCreateDebtDescription}
          handleUpdate={handleUpdateDebt}
          handleBlurUpdate={handleBlurUpdateDebt}
          handleChangeTransaction={handleChangeTransaction}
          handleAddTransaction={handleAddTransaction}
          handleRemoveTransaction={handleRemoveTransaction}
          handleChangeWeekly={handleChangeWeekly}
          handleDebtSort={handleDebtSort}
          handleDebtRefresh={handleDebtRefresh}
          yearCalc={userData.selectedProfile.yearCalc}
          sortOptions={sortOptions}
          selectedSort={selectedSort}
          setSelectedSort={setSelectedSort}
          data={debtData}
          remaining={+incomeData.monthlyTotal - +expenseData.monthlyTotal - (+incomeData.monthlyTotal*0.02)}
        />
      </Row>
    },
    {key: 'user-guide', title:'User Guide', shortTitle: 'Guide', content:
      <UserGuide />
    },
    {key: 'blog', title:'Finance Guide', shortTitle: 'Blog', content:
      <Blog />
    },
  ];
  
  return (
    <div className={`App${userData.loggedIn ? ' has-save-actions' : ''}`}>
      <header className="App-header">
        <h1>Budget App</h1>
        <p style={{fontSize: '0.8em'}}>from opensource cafe ltd</p>
      </header>
      <Container fluid className="App-container">
        <div className="page-navigation">
        <SettingsPane title="Settings">
          <Form>            
            {userData.loggedIn?
            <>
            <Row>              
              <p>Logged in as {userData.email}</p>
              <Button variant="secondary" onClick={() => handleLogOut()}>
                Log out
              </Button>
            </Row>
            <Row style={{marginTop: '15px'}}>
              <h6>MFA Settings</h6>
              <Form.Check
                disabled
                type="switch"
                id="mfa-switch"
                label="Multi-factor Authentication Enabled"
                checked={userData.mfaEnabled}
                onChange={(e) => handleMfaEnabled(e.target.checked)}
              />
              {userData.mfaEnabled?
                <>
                  <p>Multi-factor authentication is currently enabled on your account. This provides an additional layer 
                    of security by requiring a second form of verification when logging in.</p>
                    <Button variant="danger" size="sm" onClick={() => {
                      setConfirmTitle('Please confirm');
                      setConfirmMessage('Are you sure you want to disable MFA for your account?');
                      setConfirmButtonType('danger');
                      setConfirmButtonText('Disable MFA');
                      setOnConfirm(() => handleDisableMfa);
                      setConfirmShow(true);
                    }}>
                      Disable MFA
                    </Button>
                </>:
                <>
                <p>Multi-factor authentication is currently disabled on your account. We highly recommend enabling 
                  MFA in your account settings for enhanced security.</p>
                  <Button variant="outline-primary" size="sm" onClick={() => setMfaShow(true)}>
                    Enable MFA
                  </Button>               
                </>
              }              
            </Row>
            <Row style={{marginTop: '15px'}}>
              <h5>Profiles</h5>
              <Form.Select aria-label="select profile"
                key="profile"
                id="profile-select"
                value={userData.selectedProfile.id}
                onChange={(e) => {  
                  getProfile(e.target.value);     
                }}
              >
                {profiles.map((u, i) => (
                  <option key={u.id || i} value={u.id}>{u.name}</option>
                ))}
              </Form.Select>
            </Row>
            <Row>
              <Form.Control
                key='profileName'
                id='profileName'
                type="text"
                name="profileName"
                placeholder="New/Edit Profile Name"
                value={newProfileName}
                onChange={(e) => setNewProfileName(e.target.value)}
              />
            </Row>
            <Row>
              <Col xs={3}>
                <Button size="sm" onClick={() => {
                  if (profiles.length < 4) {
                    handleCreateProfile(
                      newProfileName,
                      {...initialIncome},
                      {...initialExpense},
                      {...initialDebt},
                      true
                    )                
                    handleReloadSaved('', newProfileName, initialIncome, initialExpense, initialDebt, true);
                    setNewProfileName('');
                  } else {
                    setErrorShow(true);
                    setErrorTitle("Maximum Profiles Reached");
                    setErrorMessage("You have reached the maximum number of profiles allowed. Please delete an existing profile to create a new one.");
                    setNewProfileName('');
                  }                    
                }}>
                  Create profile
                </Button>                
              </Col>
              <Col xs={3}>
                <Button variant="secondary" size="sm" onClick={() => {
                  setEditingProfile(!editingProfile);
                  setNewProfileName(editingProfile?'':userData.selectedProfile.name);                  
                }}>
                  {editingProfile?"Cancel edit":"Edit Selected"}
                </Button>
              </Col>
              {editingProfile?
              <>
                <Col xs={3}>
                  <Button variant="info" size="sm" onClick={() => {
                    profileDispatch({
                      type: "UPDATE_NAME",
                      name: userData.selectedProfile.name,
                      newName: newProfileName
                    });
                    userDispatch({
                      type: "UPDATE_SELECTED_PROFILE_NAME",
                      name: newProfileName,
                    });
                    setNewProfileName('');
                    setEditingProfile(!editingProfile);
                  }}>
                    Confirm edit
                  </Button>
                </Col>
                <Col xs={3}>
                  <Button variant="outline-danger" size="sm" onClick={() => {
                    if (profiles.length === 1) {
                      setErrorShow(true);
                      setErrorTitle("One Profile Required");
                      setErrorMessage("You have reached the minimum number of profiles allowed. Please create a new profile before deleting this one.");
                      return;
                    }
                    setConfirmTitle('Please confirm');
                    setConfirmMessage('Are you sure you want to delete your profile? All your saved data for this profile will be lost.');
                    setConfirmButtonType('danger');
                    setConfirmButtonText('Delete');
                    setOnConfirm(() => handleDeleteProfile);
                    setConfirmArgs([newProfileName]);
                    setConfirmShow(true);
                  }}>
                    Delete Profile
                  </Button>
                </Col>
              </>:<></>}
            </Row>
            </>:
            <>
              <Row>
                <Button className="manual-login-button" variant="secondary" onClick={() => setLoginShow(true)}>
                  Log in
                </Button>
                <LoginModal
                  show={loginShow}
                  setShow={setLoginShow}
                  setShowMfa={setMfaVerificationShow}
                  setMfaDetails={setMfaDetails}
                  setErrorMessage={setErrorMessage}
                  setErrorTitle={setErrorTitle}
                  setErrorShow={setErrorShow}
                  setActivateShow={setActivateShow}
                  setActivateTitle={setActivateTitle}
                  setActivateMessage={setActivateMessage}
                  setActivateSuccess={setActivateSuccess}
                  setLoading={setLoading}
                  handleLoggedIn={handleLoggedIn}
                  handleEmailUpdate={handleEmailUpdate}
                  handleNameUpdate={handleNameUpdate}
                  handleSurnameUpdate={handleSurnameUpdate}
                  handleSave={handleSave}
                  income={incomeData}
                  expenses={expenseData}
                  debt={debtData}
                  profile={profiles.find(({ name }) => name === userData.selectedProfile.name)}
                  handleMfaEnabled={handleMfaEnabled}
                  handleMfaType={handleMfaType}
                />
              </Row>
              <Row>
                <GoogleAuth
                  handleLoggedIn={handleLoggedIn}
                  handleEmailUpdate={handleEmailUpdate}
                  handleNameUpdate={handleNameUpdate}
                  handleSurnameUpdate={handleSurnameUpdate}
                  handleSave={handleSave}
                  income={incomeData}
                  expenses={expenseData}
                  debt={debtData}
                  profile={profiles.find(({ name }) => name === userData.selectedProfile.name)}
                  setErrorTitle={setErrorTitle}
                  setErrorMessage={setErrorMessage}
                  setErrorShow={setErrorShow}
                  setLoading={setLoading}
                  setShowMfa={setMfaVerificationShow}
                  setMfaDetails={setMfaDetails}
                />
              </Row>
            </>}
            <Row style={{marginTop: '15px'}}>
              <h6>Calculation Settings</h6>
              <Form.Check
                type="switch"
                id="year-calc-switch"
                checked={userData.selectedProfile.yearCalc}
                value={userData.selectedProfile.yearCalc}
                label="Monthy(Divide by 4)/Yearly(Divide by 52) weekly Calculations"
                onChange={() => handleYearCalcSwitch()}
              />
            </Row>
            {userData.loggedIn?
            <Row>
              <Col xs={12}>
                <Button 
                  style={{ bottom: '1px', position: 'absolute' }}
                  variant="danger"
                  onClick={() => {
                    setConfirmTitle('Please confirm');
                    setConfirmMessage('Are you sure you want to delete your account? All your saved data will be lost.');
                    setConfirmButtonType('danger');
                    setConfirmButtonText('Delete');
                    setOnConfirm(() => sendDeleteUser);
                    setConfirmShow(true);
                  }}
                >
                  Delete Account
                </Button>
              </Col>
            </Row>:<></>}
          </Form>
        </SettingsPane>
        <PageTabs tabs={tabs}/>
        </div>
        {userData.loggedIn?
        <SaveBlock
          save={handleSave}
          fetchProfile={getProfile}
          id={userData.selectedProfile.id}
          name={userData.selectedProfile.name}
          yearCalc={userData.selectedProfile.yearCalc}
          income={incomeData}
          expenses={expenseData}
          debt={debtData}
          profile={profiles.find(({ name }) => name === userData.selectedProfile.name)}
          setErrorShow={setErrorShow}
          setErrorTitle={setErrorTitle}
          setErrorMessage={setErrorMessage}
          setLoading={setLoading}
          handleLogOut={handleLogOut}
        />
        :<></>}
        <ErrorModal
          show={errorShow}
          setShow={setErrorShow}
          title={errorTitle}
          message={errorMessage}
        />
        <ConfirmationModal
          show={confirmShow}
          handleClose={() => setConfirmShow(false)}
          title={confirmTitle}
          bodyText={confirmMessage}
          buttonType={confirmButtonType}
          buttonText={confirmButtonText}
          onConfirm={onConfirm}
          confirmArgs={confirmArgs}
        />
        <ActivationModal
          show={activateShow}
          setShow={setActivateShow}
          title={activateTitle}
          message={activateMessage}
          success={activateSuccess}
          setLoading={setLoading}
          setErrorMessage={setErrorMessage}
          setErrorTitle={setErrorTitle}
          setErrorShow={setErrorShow}
        />
        <MfaModal
          show={mfaShow}
          setShow={setMfaShow}
          user={userData}
          handleMfaEnabled={handleMfaEnabled}
          handleMfaType={handleMfaType}
          handleDisableMfa={handleDisableMfa}
          setErrorMessage={setErrorMessage}
          setErrorTitle={setErrorTitle}
          setErrorShow={setErrorShow}
        />
        <MfaVerificationModal
          show={mfaVerificationShow}
          setShow={setMfaVerificationShow}
          mfaDetails={mfaDetails}
          setErrorMessage={setErrorMessage}
          setErrorTitle={setErrorTitle}
          setErrorShow={setErrorShow}
          setActivateShow={setActivateShow}
          setActivateTitle={setActivateTitle}
          setActivateMessage={setActivateMessage}
          setActivateSuccess={setActivateSuccess}
          setLoading={setLoading}
          handleLoggedIn={handleLoggedIn}
          handleEmailUpdate={handleEmailUpdate}
          handleNameUpdate={handleNameUpdate}
          handleSurnameUpdate={handleSurnameUpdate}
          handleMfaEnabled={handleMfaEnabled}
          handleMfaType={handleMfaType}
          handleSave={handleSave}
          income={incomeData}
          expenses={expenseData}
          debt={debtData}
          profile={profiles.find(({ name }) => name === userData.selectedProfile.name)}
        />
        {loading?
          <div className="loading-overlay">
            <Spinner animation="border" />
          </div>          
          :<></>
        }
        <Tooltip anchorSelect=".react-select-style" place="top">
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <span>Click then scroll down to see more options.</span>
            <span>You can also start typing to filter the options</span>
            <span>or create a new one.</span>
          </div>
        </Tooltip>
        <Footer />
      </Container>
    </div>
  );
}

export default App;